import {useContext, useState, useEffect, useRef} from 'react';
import {IDEContext} from '../contexts/IDEContext';
import {Editor, OnMount} from '@monaco-editor/react';
import {ProfileContext} from 'contexts/ProfileContext';
import {FaEdit} from 'react-icons/fa';
import Gate from 'contexts/Gate';
import {CourseContext} from 'contexts/CourseContext';
import {useCourseId} from 'hooks/router/useUrlParams';
import {getFirestore, doc, getDoc, setDoc} from 'firebase/firestore';
import {isMinimumRole} from 'contexts/profileUtil';
import {Role} from 'types/role';
import {Button} from 'react-bootstrap';
import { useUserId } from 'hooks/user/useUserId';

export const ResizableCodeInput = ({
  onChange,
  isReadOnly,
  code = '',
  isOffline = false,
}) => {
  const {
    editorRef,
    editorLoaded,
    setEditorLoaded,
    editorFontSize,
    selectedTab,
  } = useContext(IDEContext);
  const {courseHasGrades} = useContext(CourseContext);
  const courseId = useCourseId();
  const userId = useUserId();

  // Particularly used for inline comments
  const {userData} = useContext(ProfileContext);


  const onMount: OnMount = (editor, monaco) => {
    editorRef.current = editor;
    setEditorLoaded(!editorLoaded);


    // Add right-click command
    if (!courseHasGrades) return;

  };

  if (isOffline) {
    <div className="h-100 w-100 d-flex overflow-hidden">
      <Editor
        height="100%"
        defaultLanguage="python"
        onChange={onChange}
        onMount={onMount}
        options={{
          fontSize: editorFontSize,
          minimap: {enabled: false},
          readOnly: isReadOnly,
        }}
        width={'100%'}
        value={code}
      />
    </div>;
  }
  const instructorFeedbackButtonStyle = {
    display: selectedTab === 'Feedback' ? 'block' : 'none',
  };
  return (
    <div className="h-100 w-100 d-flex overflow-hidden">
      {isMinimumRole(userData?.courseRole, Role.SECTION_LEADER) && (
        <Button
          id="selectionButton"
          style={instructorFeedbackButtonStyle}
          variant="light"
        >
          <FaEdit />
        </Button>
      )}
      <Editor
        height="100%"
        defaultLanguage="python"
        onChange={onChange}
        onMount={onMount}
        options={{
          fontSize: editorFontSize,
          minimap: {enabled: false},
          readOnly: isReadOnly,
        }}
        width={'100%'}
      />
    </div>
  );
};
